import React from 'react';
import StatusHelpLine from './StatusHelpLine';

export default function RequestStatuses() {
  return (
    <div style={{ border: '2px solid transparent', padding: '0 0.5em' }}>
      <div className="font-weight-bold text-center" style={{ marginTop: '1em' }}>
        Request Statuses
      </div>

      <StatusHelpLine
        status="Pending"
        tooltip="The funding request for this article is waiting to be approved or denied."
      />

      <StatusHelpLine
        status="Approved"
        tooltip="The funding request for this article has been approved and will be deducted from the available balance after editorial acceptance, if balance is available."
      />

      <StatusHelpLine
        status="Funding Confirmed"
        tooltip="The funding request for this article has been approved and has been deducted from the available balance."
      />

      <StatusHelpLine status="Denied" tooltip="The funding request for this article has been denied." />

      <StatusHelpLine
        status="No Funding Provided"
        tooltip="The funding request for this article has been cancelled. It will not be charged to the account balance. Funding request cancellation can occur when a gold open access article is not accepted for publication, when an article is rejected by the system due to lack of available balance or when an author updates their metadata such that an existing funding request is no longer valid."
      />
    </div>
  );
}
